import get from 'lodash.get';

const getSitesCount = (rootState) => get(rootState, 'sites.data.count', null);

export default getSitesCount;
